import React, { Component } from 'react'
import TimelineHorizontal from '../../comum/components/TimelineHorizontal'
import { formataComTParaDiaMesAno } from '../../../utils/formatar'
import { normalizarString } from '../../../utils/functions'
import moment from 'moment'
import PopupOpenDarkIcone from '../../comum/components/PopupOpenDarkIcone'
import { IconeCadeadoBorda, Baixar } from '../../comum/components/Icones'
import { toJS } from 'mobx'
import { inject } from 'mobx-react'
import DownloadPopupIcone from './../../comum/components/DownloadDarkIcone';

@inject('store')
export default class TimelineAcomp extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller;
        this.loginStore = this.props.store.loginStore;
        this.dados = [];
        this.gerarDadosTimeline = this.gerarDadosTimeline.bind(this);
        this.timelineOnClickFunction = this.timelineOnClickFunction.bind(this);
        this.returnIcon = this.returnIcon.bind(this);
        this.tooltips = [
            {
                campo: "Descarga",
                hint: "Data de descarga do primeiro container".toUpperCase(),
                terminalVisibility: true
            },
            {
                campo: "Chegada da Carga",
                hint: "Entrada do ultimo container associado ao booking".toUpperCase(),
                terminalVisibility : process.env.ssa
            },
            {
                campo: "Liberaçao Documental",
                hint: "Liberação do último container".toUpperCase(),
                terminalVisibility: true
            }
        ]

    }

    gerarDadosTimeline = () => {
        this.dados = this.controller.dadosTimeline.map((dado, index, dados) => {
            const posterior = index === dados.length - 1 ? null : dados[index + 1];
            
            let iconPopUp = dado.icon;
            let linkItem = dado.link ? dado.link : null;

            if(posterior && [normalizarString("Solicitação de Serviços").toUpperCase(), 
                            normalizarString("Estimativa de Cálculo").toUpperCase(), 
                            normalizarString("Faturamento").toUpperCase(), 
                            normalizarString("Faturado com emissão de NFe").toUpperCase(), 
                            normalizarString("Faturado sem emissão de NFe").toUpperCase(), 
                            normalizarString("Orçamento / Pagamento").toUpperCase(),
                            normalizarString("Agendamento").toUpperCase()].includes(posterior.Normalizado) && dado.Data){
                dados[index + 1].Data = true;
            }

            if (process.env.rig && normalizarString("Agendamento").toUpperCase()===dado.Normalizado)
            {
                iconPopUp = posterior ? (posterior.Data ? true : false) : (dado.Data ? true : false);
                linkItem  = posterior ? (posterior.Data ? dado.link : null) : (dado.Data ? dado.link : null);
            }
            if (process.env.ssa && normalizarString("Liberação Documental").toUpperCase()===dado.Normalizado)
            {
                iconPopUp = posterior ? (posterior.Data ? true : false) : (dado.Data ? true : false);
                linkItem  = posterior ? (posterior.Data ? dado.link : null) : (dado.Data ? dado.link : null);
            }
            if (process.env.ssa && normalizarString("Estimativa de Cálculo").toUpperCase()===dado.Normalizado)
            {
                iconPopUp = posterior ? (posterior.Data ? true : false) : (dado.Data ? true : false);
                linkItem  = posterior ? (posterior.Data ? dado.link : null) : (dado.Data ? dado.link : null);
            }
            if (process.env.ssa && normalizarString("Faturamento").toUpperCase()===dado.Normalizado)
            {
                iconPopUp = posterior ? (posterior.Data ? true : false) : (dado.Data ? true : false);
                linkItem  = posterior ? (posterior.Data ? dado.link : null) : (dado.Data ? dado.link : null);
            }
            if (process.env.ssa && normalizarString("Faturamento").toUpperCase()===dado.Normalizado)
            {
                iconPopUp = posterior ? (posterior.Data ? true : false) : (dado.Data ? true : false);
                linkItem  = posterior ? (posterior.Data ? dado.link : null) : (dado.Data ? dado.link : null);
            }
            if (process.env.ssa && normalizarString("Presença de Carga").toUpperCase()===dado.Normalizado)
            {
                iconPopUp = posterior ? (posterior.Data ? true : false) : (dado.Data ? true : false);
                linkItem  = posterior ? (posterior.Data ? dado.link : null) : (dado.Data ? dado.link : null);
            }
            return ({
                order: dado.Ordem,
                status_name: dado.Estagio,
                status: dado.Data || dado.Msg === "OK" ? "selected" : "inactive",
                line_control: this.lineControl(dado.Data ? dado.Data : dado.Msg === "OK", index, dados),
                information: dado.Data && typeof(dado.Data) !== 'boolean' && formataComTParaDiaMesAno(dado.Data),
                sub_information: dado.Data && typeof(dado.Data) !== 'boolean' && moment(dado.Data).format("HH:mm"),
                onClick: this.timelineOnClickFunction(dado.Estagio), //No futuro devo fazer uma verificação para links e para averbação
                icon:  iconPopUp ? (dado.Data ? this.returnIcon(dado.Estagio) : <IconeCadeadoBorda />) : "",
                borderRadius: false,
                link : linkItem,                
                voltar : dado.voltar ? dado.voltar : null,
                exibirLink : dado.terminalVisibility.length > 0 ? (process.env.rig ? dado.terminalVisibility[0]==="RIG" : dado.terminalVisibility[0]==="SSA") : true,
            }) 
        });
    }

    returnIcon = (estagio) => {
        switch(estagio) {
            case 'Presença de Carga':
                return <DownloadPopupIcone className="card-detalhe--pop-icon" />
            default:
                return <PopupOpenDarkIcone className="card-detalhe--pop-icon" />;
        }
    }

    timelineOnClickFunction = (estagio) => {
        switch(estagio) {
            case 'Averbação':
                return this.loginStore.can("AcompanhamentoProcesso", "AV") && this.controller.abrirAverbacao;
            case 'Presença de Carga':
                return this.controller.baixarRelatorioPresenca;
            default:
                return null;
        }
    }

    lineControl = (dado, index, array) => {
        const anterior = index === 0 ? null : array[index - 1];
        const posterior = index === array.length - 1 ? null : array[index + 1]
        let objReturn = {
            before: null,
            mid: null,
            after: null
        }
        
        if(dado){
            if(posterior){
                if(posterior.Data || posterior.Msg === 'OK'){
                    objReturn.after = "active";
                }else{
                    objReturn.mid = "selected";
                    objReturn.after = "inactive";
                }
            }else{
                objReturn.after = null;
            }

            if(anterior){
                if(anterior.Data || anterior.Msg === 'OK'){
                    objReturn.before = "active";
                }else{
                    objReturn.before = "inactive";
                }
            }else{
                objReturn.before = null;
            }
            if(!objReturn.mid) objReturn.mid = "active";
        }else{
            if(index === 0){
                objReturn.before = null;
            }else{
                objReturn.before = "inactive";
            }
            objReturn.mid = "inactive";
            if(posterior){
                objReturn.after = "inactive";
            }else{
                objReturn.after = null;
            }
        }
        
        return objReturn;
    }

    encontrarUltimaData = (index) => {
        const tamDados = this.controller.dadosTimeline.length;
        const dadosTL = toJS(this.controller.dadosTimeline)
        if(index === tamDados - 1){
            return 'selected'
        }else if(dadosTL[index].Data){
            if(!dadosTL[index + 1].Data){
                return 'selected'
            }else{
                return 'active'
            }
        }else{
            return 'inactive'
        }
    }

    render() {
       this.gerarDadosTimeline();
        return (
            <div>
                <h2>Timeline</h2>
                <TimelineHorizontal
                    controller={this.controller}
                    information={this.dados}
                    tooltips={this.tooltips}
                    position={"bottom"}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/TimelineAcomp.js